<template>
  <div>
    <div>
      <v-btn @click="close" fab dark x-small color="red">
        <v-icon>mdi-cancel</v-icon>
      </v-btn>
      <v-btn v-if="value != unsavedValue" @click="save" fab dark x-small color="blue">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </div>
    <div ref="editor" :v-html="unsavedValue" style="min-height:200px"></div>
  </div>
</template>

<script>
// import Quill from "quill";
import jQuery from "jquery";
import "bootstrap";

import "summernote";

export default {
  name: "Editor",
  components: {},
  props: {
    value: String,
  },
  data: () => ({
    unsavedValue: String,
    editor: null,
  }),
  /* eslint-disable no-unused-vars */
  mounted() {
    this.unsavedValue = this.value;
    (function ($, _this) {
      _this.editorElement = $(_this.$refs.editor); // I like to use refs instead of $(selector)
      const editor = _this.editorElement.summernote({
        placeholder: "enter content here...",
      });
      if (_this.unsavedValue) {
        editor.summernote("code", _this.unsavedValue);
      }
      editor.on("summernote.change", (we, contents, $editable) => {
        console.log(
          "summernote's content is changed.",
          we,
          contents,
          $editable
        );
        _this.unsavedValue = contents;
      });
    })(jQuery, this);
  },

  beforeDestroy() {},
  methods: {
    save: function () {
      this.$emit("input", this.unsavedValue);
      this.close();
    },
    close: function () {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss"></style>
